import { FormInstance } from "antd/es/form";
import React from "react";
import { IValidationData } from "../../models/dto/validation-data";
import { KContext } from "../../shared/hoc/with-context";
import { KNavigator } from "../../shared/hoc/with-history";
import { KuikaAppManager } from "../../shared/utilty/kuika-app-manager";
import { KMainFunctions } from "../../shared/utilty/main-functions";
import { ReactSystemFunctions } from "../../shared/utilty/react-system-functions";

declare let window: any;

export interface IYolcuForm_ScreenProps {
  navigator: KNavigator;
  form: FormInstance<any>;
  googleLogin: any;
  screenInputs: any;
  context: KContext;
  initialValues: any;
  children: any;
}

interface IYolcuForm_ScreenState {
  isSpinnerVisible: boolean;
  isPageVisible: boolean;
  isLeftMenuVisible: boolean;
  spinnerCount: number;
  selectedLanguage: string;
  isPageInitLoaded: false;
  isPageRecurringLoaded: false;
  GoBack: any;
  GoBack_dummy: any;
  YolcuTmpAyniAdSoyadVar: any[];
  YolcuTmpAyniAdSoyadVar_dummy: any[];
  Notify: boolean;
  Notify_dummy: boolean;
  SaveRecord_1: number;
  SaveRecord_1_dummy: number;
  IfThenElse: boolean;
  IfThenElse_dummy: boolean;
  TriggerEvent: string;
  TriggerEvent_dummy: string;
  KisiYolcuListe: any[];
  KisiYolcuListe_dummy: any[];
  AgirlikBaremListe: any[];
  AgirlikBaremListe_dummy: any[];
  YolcuTmpGetir: any[];
  YolcuTmpGetir_dummy: any[];
  ChangeEnabledOf: any;
  ChangeEnabledOf_dummy: any;
  SetValueOf: any;
  SetValueOf_dummy: any;
  isComp2000857Enabled: "enabled" | "disabled";
  isComp4373449Enabled: "enabled" | "disabled";
}

export class YolcuForm_ScreenBase extends React.PureComponent<
  IYolcuForm_ScreenProps,
  any
> {
  yolcuform_4373449_value_kuikaSelectBoxRef: React.RefObject<any>;
  yolcuform_3110580_value_kuikaSelectBoxRef: React.RefObject<any>;
  ml = [
    {
      Id: "bd00ad4a-ed44-61e3-4813-27fcfc1bccc8",
      Name: "tr_TR",
      ShortName: "Turkish",
      IsDefault: true,
      LanguagePhrases: [],
    },
    {
      Id: "9f0b40ca-a5d3-4b72-bc52-230e83587430",
      Name: "en_US",
      ShortName: "English",
      LanguagePhrases: [],
    },
    {
      Id: "3b27ad9c-cbda-4ff8-844e-a28dc96b6f4e",
      Name: "FixedValues",
      ShortName: "FixedValues",
      LanguagePhrases: [
        { Id: 278335, PropertyName: "label", Value: "Vazgeç" },
        { Id: 273309, PropertyName: "label", Value: "Kaydet" },
        { Id: 769609, PropertyName: "value", Value: "Yolcu Kaydı" },
        { Id: 5053812, PropertyName: "value", Value: "Kayıtlı/Kayıtsız" },
        { Id: 5133595, PropertyName: "value", Value: "Kayıtlı Yolcu" },
        { Id: 4373449, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 1731941, PropertyName: "value", Value: "Ad Soyad" },
        { Id: 2000857, PropertyName: "placeholder", Value: "Type here..." },
        { Id: 3528276, PropertyName: "value", Value: "Ağırlık (Kg)" },
        { Id: 3110580, PropertyName: "placeholder", Value: "Choose one..." },
        { Id: 9299106, PropertyName: "value", Value: "Bagaj Adet" },
        { Id: 5625436, PropertyName: "value", Value: "Bagaj Ağırlık (Kg)" },
      ],
    },
  ];
  defaultML = "tr_TR";

  screenHash = "";

  constructor(props) {
    super(props);
    this.yolcuform_4373449_value_kuikaSelectBoxRef = React.createRef();
    this.yolcuform_2000857_value_kuikaTextInputRef = React.createRef();
    this.yolcuform_3110580_value_kuikaSelectBoxRef = React.createRef();

    this.state = {
      isSpinnerVisible: false,
      isPageVisible: false,
      isLeftMenuVisible: false,
      spinnerCount: 0,
      selectedLanguage: "",
      isPageInitLoaded: false,
      isPageRecurringLoaded: false,
      GoBack: "",
      YolcuTmpAyniAdSoyadVar: [],
      IfThenElse: false,
      TriggerEvent: "",
      KisiYolcuListe: [],
      AgirlikBaremListe: [],
      YolcuTmpGetir: [],
      SetValueOf: "",
      isComp2000857Enabled: "enabled",
      isComp4373449Enabled: "enabled",
    };

    this.state.isPageVisible = true;
  }

  async componentDidMount() {
    if (KuikaAppManager.isPageInitPrevented()) {
      KuikaAppManager.calculateAndSetBodyHeight("yolcuform", "");
      return;
    }

    ReactSystemFunctions.validateToken();
    this.fillFormInitValues();
    if (true) {
      await this.YolcuFormPageInit();
    }

    KuikaAppManager.calculateAndSetBodyHeight("yolcuform", "");

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = this;
    }
  }

  componentWillUnmount() {
    if (ReactSystemFunctions.getIsMicroApp() === false) {
      window.parentScreen = null;
    }
  }

  componentDidUpdate = async (prevProps, prevState) => {
    KuikaAppManager.calculateAndSetBodyHeight("yolcuform", "");
    if (prevProps?.location?.search !== (this.props as any)?.location?.search) {
      await this.YolcuFormPageInit();
    }

    if (ReactSystemFunctions.getIsMicroApp() === false) {
      for (const key in prevState) {
        if (
          key.startsWith("NavVisible") &&
          prevState[key] === true &&
          this.state[key] === false
        ) {
          window.parentScreen = this;
          break;
        }
      }
    }
  };

  fillFormInitValues() {
    this.props.form?.setFieldsValue({
      yolcuform_2252874_value:
        this.state.YolcuTmpGetir?.at?.(0)?.isManuel ?? undefined,
      yolcuform_4373449_value:
        this.state.YolcuTmpGetir?.at?.(0)?.kisiId ?? undefined,
      yolcuform_2000857_value:
        this.state.YolcuTmpGetir?.at?.(0)?.adSoyad ?? undefined,
      yolcuform_3110580_value:
        this.state.YolcuTmpGetir?.at?.(0)?.agirlik ?? undefined,
      yolcuform_3850512_value:
        this.state.YolcuTmpGetir?.at?.(0)?.bagajAdet ?? undefined,
      yolcuform_3339939_value:
        this.state.YolcuTmpGetir?.at?.(0)?.bagajAgirlik ?? undefined,
    });
  }

  setPageInitLoaded = (value: boolean) => {
    this.setState({ isPageInitLoaded: value });
  };

  setPageRecurringLoaded = (value: boolean) => {
    this.setState({ isPageRecurringLoaded: value });
  };

  clearFieldValidation = (changedValues: any) => {
    const fieldName = Object.keys(changedValues)[0];
    if (fieldName) {
      this.props.form?.setFields([
        {
          name: fieldName,
          errors: [],
        },
      ]);
    }
  };

  YolcuFormPageInit = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    let localVar = {
      Id_2: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YolcuForm/YolcuFormPageInit",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.KisiYolcuListe = result?.data.kisiYolcuListe;

    formVars.yolcuform_4373449_value =
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].kisiId
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].kisiId
        : null;
    formVars.yolcuform_4373449_options = stateVars.KisiYolcuListe;
    stateVars.AgirlikBaremListe = result?.data.agirlikBaremListe;

    formVars.yolcuform_3110580_value =
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].agirlik
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].agirlik
        : null;
    formVars.yolcuform_3110580_options = stateVars.AgirlikBaremListe;
    stateVars.YolcuTmpGetir = result?.data.yolcuTmpGetir;
    formVars.yolcuform_2252874_value = ReactSystemFunctions.value(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].isManuel
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].isManuel
        : null
    );
    formVars.yolcuform_4373449_value =
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].kisiId
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].kisiId
        : null;
    formVars.yolcuform_4373449_options = stateVars.KisiYolcuListe;
    formVars.yolcuform_2000857_value = ReactSystemFunctions.toString(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].adSoyad
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].adSoyad
        : null
    );
    formVars.yolcuform_3110580_value =
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].agirlik
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].agirlik
        : null;
    formVars.yolcuform_3110580_options = stateVars.AgirlikBaremListe;
    formVars.yolcuform_3850512_value = ReactSystemFunctions.value(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].bagajAdet
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].bagajAdet
        : null
    );
    formVars.yolcuform_3339939_value = ReactSystemFunctions.value(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].bagajAgirlik
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].bagajAgirlik
        : null
    );
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YolcuFormPageInit1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YolcuFormPageInit_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp2000857Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );
    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp4373449Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("disabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YolcuFormPageInit_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp2000857Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("disabled", "string")
    );
    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp4373449Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YolcuFormPageInit1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_2252874_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred = await this.YolcuFormPageInit_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.YolcuFormPageInit_else1();
      if (isErrorOccurred) return true;
    }

    formVars.yolcuform_2252874_value = ReactSystemFunctions.value(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].isManuel
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].isManuel
        : null
    );

    formVars.yolcuform_4373449_value = ReactSystemFunctions.toString(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].kisiId
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].kisiId
        : null
    );

    stateVars.dataSource_4373449 =
      stateVars.KisiYolcuListe ?? this.state.KisiYolcuListe;
    stateVars.dataSource_4373449 =
      stateVars.KisiYolcuListe ?? this.state.KisiYolcuListe;
    formVars.yolcuform_2000857_value = ReactSystemFunctions.toString(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].adSoyad
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].adSoyad
        : null
    );

    formVars.yolcuform_3110580_value = ReactSystemFunctions.toString(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].agirlik
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].agirlik
        : null
    );

    stateVars.dataSource_3110580 =
      stateVars.AgirlikBaremListe ?? this.state.AgirlikBaremListe;
    stateVars.dataSource_3110580 =
      stateVars.AgirlikBaremListe ?? this.state.AgirlikBaremListe;
    formVars.yolcuform_3850512_value = ReactSystemFunctions.value(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].bagajAdet
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].bagajAdet
        : null
    );

    formVars.yolcuform_3339939_value = ReactSystemFunctions.value(
      this,
      stateVars.YolcuTmpGetir !== undefined
        ? stateVars.YolcuTmpGetir?.length > 0
          ? stateVars.YolcuTmpGetir[0].bagajAgirlik
          : null
        : this.state.YolcuTmpGetir?.length > 0
        ? this.state.YolcuTmpGetir[0].bagajAgirlik
        : null
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    this.setPageInitLoaded(true);
    return isErrorOccurred;
  };

  YolcuFormComponent_278335_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }

    stateVars.Confirm = await ReactSystemFunctions.confirmation(
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "bfcbf34f_e361_1dc0_5958_38ecc7749dd8_confirmation",
        this.defaultML,
        "Kaydetmeden çıkmak istediğinize emin misiniz?"
      ),
      "poppins",
      "UYARI",
      "confirmation",
      "#246dff"
    );

    if (stateVars.Confirm) {
      KuikaAppManager.showSpinner(this);

      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YolcuFormComponent_273309_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      AdSoyad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_2000857_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
    };

    KuikaAppManager.showSpinner(this);

    if (true) {
      KuikaAppManager.showSpinner(this);
    }
    let result = await KuikaAppManager.ApiRequest(
      this,
      "YolcuForm/YolcuFormComponent_273309_onClick",
      localVar
    );
    if (!KMainFunctions.IsResStatus2XX(result)) return true;

    stateVars.YolcuTmpAyniAdSoyadVar = result?.data.yolcuTmpAyniAdSoyadVar;
    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YolcuFormComponent_273309_onClick1_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YolcuFormComponent_273309_onClick_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.Notify = await ReactSystemFunctions.notify(
      this,
      ReactSystemFunctions.translateCustomActions(
        this.ml,
        "ebc88b94_fe09_380e_10f2_df42124339e5_notify",
        this.defaultML,
        "Bu isimde yolcu zaten eklenmiş."
      ),
      ReactSystemFunctions.convertToTypeByName("warning", "string"),
      ReactSystemFunctions.convertToTypeByName("bottom-right", "string"),
      0,
      ReactSystemFunctions.convertToTypeByName("", "string"),
      ReactSystemFunctions.convertToTypeByName("", "string"),
      0
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YolcuFormComponent_273309_onClick_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {};

    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred =
          await this.YolcuFormComponent_273309_onClick_else11_();
        resolve();
      });
    });

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YolcuFormComponent_273309_onClick_else11_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    validations.push({
      isValid:
        ReactSystemFunctions.isLessOrEqual(
          ReactSystemFunctions.value(
            this,
            ReactSystemFunctions.value(
              this,
              "yolcuform_3339939_value",
              "value",
              "",
              "",
              ""
            )
          ),
          ReactSystemFunctions.convertToTypeByName("100", "string")
        ) ||
        ReactSystemFunctions.isEmpty(
          ReactSystemFunctions.value(
            this,
            ReactSystemFunctions.value(
              this,
              "yolcuform_3339939_value",
              "value",
              "",
              "",
              ""
            )
          ),
          ReactSystemFunctions.convertToTypeByName("True", "string")
        ),
      message: "Bagaj ağırılığı en fazla 100 kg olmalıdır...",
      formName: "yolcuform_3339939_value",
      condition: true,
    } as IValidationData);

    validations.forEach((validation) => {
      if (validation.message === "Geçerli bir mail adresi giriniz.") {
        validation.message = ReactSystemFunctions.getEmailValidationMessage();
      }
    });

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.increaseServerRequestCount();

    let localVar = {
      BagajAdet_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_3850512_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      BagajAgirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_3339939_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "number"
      ),
      EditId_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.EditId ?? this.props.screenInputs.editid,
        "Guid"
      ),
      KisiId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_4373449_value",
            "value",
            "KisiYolcuListe",
            "id",
            "id"
          )
        ),
        "Guid"
      ),
      OrjId_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          stateVars.YolcuTmpGetir !== undefined
            ? stateVars.YolcuTmpGetir?.length > 0
              ? stateVars.YolcuTmpGetir[0].orjId
              : null
            : this.state.YolcuTmpGetir?.length > 0
            ? this.state.YolcuTmpGetir[0].orjId
            : null
        ),
        "Guid"
      ),
      Id_0: ReactSystemFunctions.convertToTypeByName(
        this.props.screenInputs.Id ?? this.props.screenInputs.id,
        "Guid"
      ),
      IsDegisti_0: ReactSystemFunctions.convertToTypeByName(true, "boolean"),
      IsManuel_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_2252874_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "boolean"
      ),
      AdSoyad_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_2000857_value",
            "value",
            "",
            "",
            ""
          )
        ),
        "string"
      ),
      Agirlik_0: ReactSystemFunctions.convertToTypeByName(
        ReactSystemFunctions.toString(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_3110580_value",
            "value",
            "AgirlikBaremListe",
            "ad",
            "ad"
          )
        ),
        "string"
      ),
    };

    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.YolcuTmpAyniAdSoyadVar !== undefined
            ? stateVars.YolcuTmpAyniAdSoyadVar?.length > 0
              ? stateVars.YolcuTmpAyniAdSoyadVar[0].adet
              : null
            : this.state.YolcuTmpAyniAdSoyadVar?.length > 0
            ? this.state.YolcuTmpAyniAdSoyadVar[0].adet
            : null
        ),
        ReactSystemFunctions.convertToTypeByName("0", "string")
      )
    ) {
      if (true) {
        KuikaAppManager.showSpinner(this);
      }
      let result = await KuikaAppManager.ApiRequest(
        this,
        "YolcuForm/YolcuFormComponent_273309_onClick_else11_",
        localVar
      );
      if (!KMainFunctions.IsResStatus2XX(result)) return true;

      stateVars.SaveRecord_1 = result?.data.saveRecord_1;
      this.props.form?.setFieldsValue(formVars);

      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YolcuFormComponent_273309_onClick_else12_();
          resolve();
        });
      });
    } else {
      await new Promise((resolve, reject) => {
        this.setState(stateVars, async () => {
          isErrorOccurred =
            await this.YolcuFormComponent_273309_onClick_else12_();
          resolve();
        });
      });
    }

    KuikaAppManager.hideSpinner(this);
    return isErrorOccurred;
  };
  YolcuFormComponent_273309_onClick_else12_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.YolcuTmpAyniAdSoyadVar !== undefined
            ? stateVars.YolcuTmpAyniAdSoyadVar?.length > 0
              ? stateVars.YolcuTmpAyniAdSoyadVar[0].adet
              : null
            : this.state.YolcuTmpAyniAdSoyadVar?.length > 0
            ? this.state.YolcuTmpAyniAdSoyadVar[0].adet
            : null
        ),
        "0"
      )
    ) {
      stateVars.GoBack = await ReactSystemFunctions.goBack(this, false);

      this.props.form?.setFieldsValue(formVars);
      this.setState(stateVars);
    } else {
      KuikaAppManager.hideSpinner(this);
    }

    return isErrorOccurred;
  };

  YolcuFormComponent_273309_onClick1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isNotEqualTo(
        ReactSystemFunctions.value(
          this,
          stateVars.YolcuTmpAyniAdSoyadVar !== undefined
            ? stateVars.YolcuTmpAyniAdSoyadVar?.length > 0
              ? stateVars.YolcuTmpAyniAdSoyadVar[0].adet
              : null
            : this.state.YolcuTmpAyniAdSoyadVar?.length > 0
            ? this.state.YolcuTmpAyniAdSoyadVar[0].adet
            : null
        ),
        "0"
      )
    ) {
      isErrorOccurred = await this.YolcuFormComponent_273309_onClick_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.YolcuFormComponent_273309_onClick_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YolcuFormComponent_422198_onClick = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    if (await this.YolcuFormComponent_278335_onClick()) return true;

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YolcuFormComponent_2252874_onChange_if0 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yolcuform_4373449_value",
        "string"
      ),
      "",
      null,
      "Id"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YolcuFormComponent_2252874_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_2252874_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred = await this.YolcuFormComponent_2252874_onChange_if0();
      if (isErrorOccurred) return true;
    } else {
    }
    KuikaAppManager.showSpinner(this);

    this.props.form?.setFieldsValue(formVars);

    await new Promise((resolve, reject) => {
      this.setState(stateVars, async () => {
        isErrorOccurred = await this.YolcuFormComponent_2252874_onChange1_();
        resolve();
      });
    });

    return isErrorOccurred;
  };
  YolcuFormComponent_2252874_onChange_if1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp2000857Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );
    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp4373449Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("disabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YolcuFormComponent_2252874_onChange_else1 = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp2000857Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("disabled", "string")
    );
    stateVars.ChangeEnabledOf = await ReactSystemFunctions.changeEnabledOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "isComp4373449Enabled",
        "string"
      ),
      ReactSystemFunctions.convertToTypeByName("enabled", "string")
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);

    return isErrorOccurred;
  };

  YolcuFormComponent_2252874_onChange1_ = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    if (
      ReactSystemFunctions.isEqualTo(
        ReactSystemFunctions.value(
          this,
          ReactSystemFunctions.value(
            this,
            "yolcuform_2252874_value",
            "value",
            "",
            "",
            ""
          )
        ),
        true
      )
    ) {
      isErrorOccurred = await this.YolcuFormComponent_2252874_onChange_if1();
      if (isErrorOccurred) return true;
    } else {
      isErrorOccurred = await this.YolcuFormComponent_2252874_onChange_else1();
      if (isErrorOccurred) return true;
    }

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  YolcuFormComponent_4373449_onChange = async () => {
    let stateVars = {} as any;
    let formVars = {} as any;
    let validations = [] as IValidationData[];
    let isErrorOccurred = false;

    if (KuikaAppManager.handleValidations(this, validations)) {
      const invalidValidation = validations.find(
        (v) => !v.isValid && v.condition
      );
      if (invalidValidation) {
        const formName = invalidValidation?.formName;
        const fieldId = formName?.match(/\d+/)?.[0];
        if (!formName || !fieldId) return;

        const applyError = () =>
          this.props.form?.setFields([
            {
              name: formName,
              errors: [invalidValidation.message],
              touched: true,
            },
          ]);

        applyError();
      }
      return true;
    }
    KuikaAppManager.showSpinner(this);

    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yolcuform_2000857_value",
        "string"
      ),
      ReactSystemFunctions.toString(
        this,
        ReactSystemFunctions.value(
          this,
          "yolcuform_4373449_value",
          "value",
          "KisiYolcuListe",
          "id",
          "adSoyad"
        )
      ),
      null,
      false
    );
    stateVars.SetValueOf = await ReactSystemFunctions.setValueOf(
      this,
      ReactSystemFunctions.convertToTypeByName(
        "yolcuform_3110580_value",
        "string"
      ),
      ReactSystemFunctions.value(
        this,
        ReactSystemFunctions.value(
          this,
          "yolcuform_4373449_value",
          "value",
          "KisiYolcuListe",
          "id",
          "kilo"
        )
      ),
      null,
      "Ad"
    );

    this.props.form?.setFieldsValue(formVars);
    this.setState(stateVars);
    KuikaAppManager.hideSpinner(this);

    return isErrorOccurred;
  };

  async callCallbackFunction(diId: number, isFromMaster: boolean = false) {
    let isErrorOccurred = false;
    let pageInitCallerNavDiIDs = [] as number[];
    if (isFromMaster || pageInitCallerNavDiIDs.indexOf(diId) > -1) {
      await this.YolcuFormPageInit();
    }
  }
}
